module.exports = __webpack_public_path__ + "img/banner-right-m.8c801415.png";